<template>
    <div class="paypal-button">
    </div>
</template>

<script>
    import paypal from 'paypal-checkout';
    import defaultProps from '../../utils/paypalDefaultProps';
    import additionalProps from '../../utils/paypalAdditionalProps';
    import {propTypes, assignToPropertyObject} from '../../utils/paypalProp';

    const assignTo = assignToPropertyObject(additionalProps);

    export default {
        props: Object.assign(
            defaultProps(),
            additionalProps.vmProps(),
        ),
        methods: {
            payment() {
                return this.$store.dispatch("offer/create/createTransaction", {offer: this.offer})
                    .then(function (response) {
                        return response.id;
                    });
            },
            onAuthorize(data) {
                const vue = this;
                vue.$emit('payment-authorized', data);
                return true;
            },
            onCancel(data) {
                const vue = this;
                vue.$emit('payment-cancelled', data);
            },
            onEnter() {
                const vue = this;
                vue.$emit('button-loaded');
            }
        },
        mounted() {
            const vue = this;
            const button = Object.assign({
                // Pass in env
                env: vue.env,

                // Pass the payment details for your transaction
                // See https://developer.paypal.com/docs/api/payments/#payment_create for the expected json parameters
                payment: vue.payment,

                // Display a "Pay Now" button rather than a "Continue" button
                commit: vue.commit,

                // Pass a function to be called when the customer completes the payment
                onAuthorize: vue.onAuthorize,

                // Pass a function to be called when the customer cancels the payment
                onCancel: vue.onCancel,

                // Pass a function to be called when the button is ready
                onEnter: vue.onEnter,

            }, assignTo(vue, propTypes.BUTTON));

            paypal.Button.render(button, vue.$el);
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/marketplace/PayPalCheckout.vue